<script>
	import Nav from './Nav.svelte'
	import Balance from './Balance.svelte'
	import NewOrder from './NewOrder.svelte'
	import OrderBook from './OrderBook.svelte'
	import PriceChart from './PriceChart.svelte'
	import MyTransactions from './MyTransactions.svelte'
	import Trades from './Trades.svelte'
</script>

<main>
	<div>
		<Nav/>
		<div class="content">
			<div class="vertical-split">
				<div class="card bg-dark text-white">
					<div class="card-header">Balance</div>
					<div class="card-body bg-dark text-white">
						<Balance/>
					</div>
				</div>

				<div class="card bg-dark text-white">
					<div class="card-header">New Order</div>
					<div class="card-body">
						<NewOrder/>
					</div>
				</div>
			</div>

			<div class="vertical">
				<div class="card bg-dark text-white">
					<div class="card-header">Order Book</div>
					<div class="card-body">
						<OrderBook/>
					</div>
				</div>
			</div>

			<div class="vertical-split">
				<div class="card bg-dark text-white">
					<div class="card-header">Pricechart</div>
					<div class="card-body">
						<PriceChart/>
					</div>
				</div>

				<div class="card bg-dark text-white">
					<div class="card-header">My Transactions</div>
					<div class="card-body">
						<MyTransactions/>
					</div>
				</div>
			</div>

			<div class="vertical">
				<div class="card bg-dark text-white">
					<div class="card-header">Trades</div>
					<div class="card-body">
						<Trades/>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
